<script>
    import recoverPasswordModel from "../models/recoverPasswordModel";

    export default {
        props: ["nextUrl"],
        template: require("../templates/recoverPassword.html"),
        data() {
            return {
                recoverPasswordModel: new recoverPasswordModel(),
                showDismissibleAlert: false,
                dismissibleSuccessAlert: false,
                // Theme
                themeLoginButton: this.$myThemeButton_Login,
                themeButton_success: this.$myThemeButton_success
            }
        },
        methods: {
            handleSubmit(e) {

                e.preventDefault();
                let localThis = this;
                let url = this.$localApiURL + this.recoverPasswordModel.getRoute("save");
                let isValid = this.validateEmail();


                this.recoverPasswordModel.errorMessage = "";
                this.dismissibleSuccessAlert = false;
                this.showDismissibleAlert = false;
                if (this.recoverPasswordModel.email === "") {
                    this.recoverPasswordModel.errorMessage = "Please input the user email.";
                } else if (isValid === 0) {
                    this.recoverPasswordModel.errorMessage = "Please input a valid user email.";
                }
                if (this.recoverPasswordModel.errorMessage === "") {

                    this.recoverPasswordModel.save(
                        {
                            'url': url,
                            "data": {
                                email: this.recoverPasswordModel.email
                            }
                        }
                    ).then(result => {
                        let response = result.response;
                        if (response.data != null && response.data.error === false) {
                            localThis.dismissibleSuccessAlert = true;
                            localThis.recoverPasswordModel.successMessage = response.data.message;
                        } else {
                            localThis.showDismissibleAlert = true;
                            localThis.recoverPasswordModel.errorMessage = response.data.message;
                        }
                        localThis.recoverPasswordModel.email = "";

                    }).catch((error) => {
                        localThis.showDismissibleAlert = true;
                        localThis.recoverPasswordModel.errorMessage = error;
                        console.error(error);

                    });
                } else {
                    this.showDismissibleAlert = true;
                }

            },

            validateEmail() {
                let email = this.recoverPasswordModel.email;
                let atpos = email.indexOf("@");
                let dotpos = email.lastIndexOf(".");
                if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length)
                    return 0;
                else
                    return 1;

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/RecoverPassword.vue